import React from 'react';
import { Frame, Loader, SageClassnames } from '@kajabi/sage-react';

const Loading = () => (
  <Frame align={Frame.ALIGNMENTS.LEFT} className={SageClassnames.SPACERS.SM_TOP}>
    <Loader label="" type={Loader.TYPES.TYPING} loading data-testid="message-loading" />
  </Frame>
);

export default Loading;
